import { Component, Vue, Watch } from "vue-property-decorator";
import { productStore } from "@/store/ProductModule";
import { Variant, TranslationModel, ProductModel } from "../models/product";
import { QuantityCalculationResultModel } from "../models/QuanityCalculatorCast";
import calculatorService from "../services/CalculatorService";

@Component
export default class ConsumptionCalculatorSand extends Vue {
    protected width?: number = undefined;
    protected length?: number = undefined;
    protected depth?: number = undefined;
    protected thickness?: number = undefined;
    protected jointwidth?: number = undefined;
    protected markyta?: number = undefined;
    protected translations: TranslationModel;
    protected floatLeft: object = {} as object;
    protected margin: object = {} as object;
    private isCalculating: boolean = false;

    constructor() {
        super();
        this.translations = window.__finja.translations as TranslationModel;
    }

    protected created() {
        this.width = undefined;
        this.length = undefined;
        this.depth = undefined;
        this.thickness = undefined;
        this.jointwidth = undefined;
        this.markyta = undefined;
        this.floatLeft = { float : "left"};
        this.margin = { "margin-left" : "0"};

        this.setMeasurementsFromSessionSandBox();
        this.setMeasurementsFromSessionFogSand();
    }

    get product(): ProductModel {
        return productStore.product;
    }

    get variant(): Variant {
        return productStore.variant;
    }

    get quantity(): number {
        return productStore.quantity;
    }

    get itemConsumptionCalculatorSandBoxSand(): boolean {
        return productStore.variant.itemConsumptionCalculatorSandBoxSand;
    }

    get itemConsumptionCalculatorFogSand(): boolean {
        return productStore.variant.itemConsumptionCalculatorFogSand;
    }

    get itemConsumptionCalculator(): string {
        return productStore.variant.itemConsumptionCalculator;
    }

    get itemMaterialConsumption(): number {
        return productStore.variant.itemMaterialConsumption;
    }

    @Watch("quantity")
    protected onQuantityChange(value: number, oldValue: number) {
        if (this.isCalculating) {
            return;
        }
        productStore.dispatchQuantity(value);
    }

    private calculateQuantity() {
        if (this.variant.itemConsumptionCalculatorSandBoxSand) {
            const volume = calculatorService.CalculateVolumeSandBox(this.width, this.length, this.depth);
            if (volume && this.product.productMaterialConsumption > 0 && this.variant.itemPrimaryPackagingWeight > 0) {
                const quantity = Math.ceil((volume * 1000 * this.product.productMaterialConsumption) / this.variant.itemPrimaryPackagingWeight);
                productStore.dispatchQuantity(quantity);
            } else {
                productStore.dispatchQuantity(1);
            }
        } else if (this.variant.itemConsumptionCalculatorFogSand) {
            const weight = calculatorService.CalculateWeightFogSand(this.width, this.length, this.thickness, this.jointwidth, this.markyta,
                this.variant.fogSandMultiplyingFactor);
            if (weight && this.variant.itemPrimaryPackagingWeight > 0) {
                const quantity = Math.ceil(weight / this.variant.itemPrimaryPackagingWeight);
                productStore.dispatchQuantity(quantity);
            } else {
                productStore.dispatchQuantity(1);
            }
        }
    }

    private storeSession(key: string, value: number): void {
        if (typeof(sessionStorage) !== "undefined") {
            sessionStorage.setItem(this.variant.variantId + key, value.toString());
        }
    }

    private setMeasurementsFromSessionSandBox() {
        const sandboxquantity = this.getSessionWithoutVariantId("sandboxquantity");
        if (sandboxquantity !== "") {
            const quantityCalcResults = JSON.parse(sandboxquantity);
            if (quantityCalcResults !== undefined) {
                const currentVariantData = quantityCalcResults.filter((x: QuantityCalculationResultModel)  => x.variantId === this.variant.variantId);
                if (currentVariantData.length > 0 && Number(currentVariantData[0].sack) && currentVariantData[0].sack > 0) {
                    this.width = currentVariantData[0].width;
                    this.length = currentVariantData[0].length;
                    this.depth = currentVariantData[0].depth;
                    productStore.dispatchQuantity(currentVariantData[0].sack);

                    sessionStorage.setItem("sandboxquantity", "");
                }
            }
        }
    }

    private setMeasurementsFromSessionFogSand() {
        const fogsandquantity = this.getSessionWithoutVariantId("fogsandquantity");
        if (fogsandquantity !== "") {
            const quantityCalcResults = JSON.parse(fogsandquantity);
            if (quantityCalcResults !== undefined) {
                const currentVariantData = quantityCalcResults.filter((x: QuantityCalculationResultModel)  => x.variantId === this.variant.variantId);
                if (currentVariantData.length > 0 && Number(currentVariantData[0].sack) && currentVariantData[0].sack > 0) {
                    this.width = currentVariantData[0].width;
                    this.length = currentVariantData[0].length;
                    this.thickness = currentVariantData[0].thickness;
                    this.jointwidth = currentVariantData[0].jointwidth;
                    this.markyta = currentVariantData[0].markyta;
                    productStore.dispatchQuantity(currentVariantData[0].sack);

                    sessionStorage.setItem("fogsandquantity", "");
                }
            }
        }
    }

    private getSessionWithoutVariantId(key: string): string {
        if (typeof(sessionStorage) !== "undefined") {
            return sessionStorage.getItem(key) || "";
        }

        return "";
    }
}
